// TODO: This is a temporary solution until we receive the menu object from the backend
import { Role, Route } from '@/types/auth'

const adminRoutes = [
  {
    "id": "dashboard",
    "icon": "simple-icon-grid",
    "title": "menu.dashboard",
    "path": "/dashboard"
  },
  {
    "id": "monitoring",
    "icon": "simple-icon-speedometer",
    "title": "menu.equipments",
    "path": "/monitoring"
  },
  {
    "id": "monitoringNOV",
    "icon": "simple-icon-speedometer",
    "title": "NOV",
    "path": "/monitoringNOV",
    "children": [
      {
        "icon": null,
        "title": "PM-1386",
        "path": "/monitoringNOV/PM-1386"
      },
      {
        "icon": null,
        "title": "PM-1389",
        "path": "/monitoringNOV/PM-1389"
      },
      {
        "icon": null,
        "title": "PM-1501",
        "path": "/monitoringNOV/PM-1501"
      }
    ]
  },
  {
    "id": "operational-security",
    "icon": "iconsminds-security-settings",
    "title": "menu.operational-security",
    "path": "/operational-security",
    "children": [
      {
        "icon": null,
        "title": "menu.cctv",
        "path": "/operational-security/cctv"
      },
      {
        "icon": null,
        "title": "menu.voceo",
        "path": "/operational-security/voceo"
      },
      {
        "icon": null,
        "title": "menu.access-control",
        "path": "/operational-security/access-control"
      }
    ]
  },
  {
    "id": "physical-security",
    "icon": "iconsminds-security-block",
    "title": "menu.physical-security",
    "path": "/physical-security",
    "children": [
      {
        "icon": null,
        "title": "menu.intruder-detector",
        "path": "/physical-security/intruder-detector"
      }
    ]
  },
  {
    "id": "remote-support",
    "icon": "iconsminds-gear-2",
    "title": "menu.remote-support",
    "path": "/remote-support",
    "children": [
      {
        "icon": null,
        "title": "menu.activities",
        "path": "/remote-support/activities"
      },
      {
        "icon": null,
        "title": "menu.maintenance",
        "path": "/remote-support/maintenance"
      },
      {
        "icon": null,
        "title": "menu.alerts",
        "path": "/remote-support/alerts"
      }
    ]
  },
  {
    "id": "administration",
    "icon": "iconsminds-gear-2",
    "title": "menu.admin",
    "path": "/admin",
    "children": [
      {
        "icon": null,
        "title": "menu.users",
        "path": "/admin/users"
      },
      {
        "icon": null,
        "title": "menu.equipments",
        "path": "/admin/equipments"
      },
      {
        "icon": null,
        "title": "menu.variables",
        "path": "/admin/variables"
      },
      {
        "icon": null,
        "title": "menu.devices",
        "path": "/admin/devices"
      }
    ]
  }
]

const monitoringRoutes = [
  {
    "id": "dashboard",
    "icon": "simple-icon-grid",
    "title": "menu.dashboard",
    "path": "/dashboard"
  },
  {
    "id": "monitoring",
    "icon": "simple-icon-speedometer",
    "title": "menu.equipments",
    "path": "/monitoring"
  },
  {
    "id": "monitoringNOV",
    "icon": "simple-icon-speedometer",
    "title": "NOV",
    "path": "/monitoringNOV",
    "children": [
      {
        "icon": null,
        "title": "PM-1386",
        "path": "/monitoringNOV/PM-1386"
      },
      {
        "icon": null,
        "title": "PM-1389",
        "path": "/monitoringNOV/PM-1389"
      },
      {
        "icon": null,
        "title": "PM-1501",
        "path": "/monitoringNOV/PM-1501"
      }
    ]
  },
  {
    "id": "operational-security",
    "icon": "iconsminds-security-settings",
    "title": "menu.operational-security",
    "path": "/operational-security",
    "children": [
      {
        "icon": null,
        "title": "menu.cctv",
        "path": "/operational-security/cctv"
      },
      {
        "icon": null,
        "title": "menu.voceo",
        "path": "/operational-security/voceo"
      },
      {
        "icon": null,
        "title": "menu.access-control",
        "path": "/operational-security/access-control"
      }
    ]
  },
  {
    "id": "physical-security",
    "icon": "iconsminds-security-block",
    "title": "menu.physical-security",
    "path": "/physical-security",
    "children": [
      {
        "icon": null,
        "title": "menu.intruder-detector",
        "path": "/physical-security/intruder-detector"
      }
    ]
  },
  {
    "id": "remote-support",
    "icon": "iconsminds-gear-2",
    "title": "menu.remote-support",
    "path": "/remote-support",
    "children": [
      {
        "icon": null,
        "title": "menu.activities",
        "path": "/remote-support/activities"
      },
      {
        "icon": null,
        "title": "menu.maintenance",
        "path": "/remote-support/maintenance"
      },
      {
        "icon": null,
        "title": "menu.alerts",
        "path": "/remote-support/alerts"
      }
    ]
  }
]

const maintenanceRoutes = [
  {
    "id": "dashboard",
    "icon": "simple-icon-grid",
    "title": "menu.dashboard",
    "path": "/dashboard"
  },
  {
    "id": "monitoring",
    "icon": "simple-icon-speedometer",
    "title": "menu.equipments",
    "path": "/monitoring"
  },
  {
    "id": "operational-security",
    "icon": "iconsminds-security-settings",
    "title": "menu.operational-security",
    "path": "/operational-security",
    "children": [
      {
        "icon": null,
        "title": "menu.cctv",
        "path": "/operational-security/cctv"
      },
      {
        "icon": null,
        "title": "menu.voceo",
        "path": "/operational-security/voceo"
      },
      {
        "icon": null,
        "title": "menu.access-control",
        "path": "/operational-security/access-control"
      }
    ]
  },
  {
    "id": "remote-support",
    "icon": "iconsminds-gear-2",
    "title": "menu.remote-support",
    "path": "/remote-support",
    "children": [
      {
        "icon": null,
        "title": "menu.alerts",
        "path": "/remote-support/alerts"
      }
    ]
  }
]

const supportRoutes = [
  {
    "id": "dashboard",
    "icon": "simple-icon-grid",
    "title": "menu.dashboard",
    "path": "/dashboard"
  },
  {
    "id": "monitoring",
    "icon": "simple-icon-speedometer",
    "title": "menu.equipments",
    "path": "/monitoring"
  },
  {
    "id": "operational-security",
    "icon": "iconsminds-security-settings",
    "title": "menu.operational-security",
    "path": "/operational-security",
    "children": [
      {
        "icon": null,
        "title": "menu.cctv",
        "path": "/operational-security/cctv"
      },
      {
        "icon": null,
        "title": "menu.voceo",
        "path": "/operational-security/voceo"
      },
      {
        "icon": null,
        "title": "menu.access-control",
        "path": "/operational-security/access-control"
      }
    ]
  },
  {
    "id": "physical-security",
    "icon": "iconsminds-security-block",
    "title": "menu.physical-security",
    "path": "/physical-security",
    "children": [
      {
        "icon": null,
        "title": "menu.intruder-detector",
        "path": "/physical-security/intruder-detector"
      }
    ]
  }
]

const operativeRoutes = [
  {
    "id": "dashboard",
    "icon": "simple-icon-grid",
    "title": "menu.dashboard",
    "path": "/dashboard"
  },
  {
    "id": "monitoring",
    "icon": "simple-icon-speedometer",
    "title": "menu.equipments",
    "path": "/monitoring"
  },
  {
    "id": "operational-security",
    "icon": "iconsminds-security-settings",
    "title": "menu.operational-security",
    "path": "/operational-security",
    "children": [
      {
        "icon": null,
        "title": "menu.cctv",
        "path": "/operational-security/cctv"
      }
    ]
  }
]

const routesMap = new Map<Role, any[]>([
  [Role.Administrador, adminRoutes],
  [Role.Monitorista, monitoringRoutes],
  [Role.Mantenimiento, maintenanceRoutes],
  [Role.Soporte, supportRoutes],
  [Role.Operativo, operativeRoutes]
])

export function getRoutes(role: string): Route[] {
  return routesMap.get(role as Role)?.map(route => Route.fromObject(route)) ?? []
}